import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import MidHelixPiercingImage from '../../Assets/Piercing Services/helix piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function MidHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Mid Helix Piercing UAE | 150 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Mid Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Mid Helix Piercing 150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={MidHelixPiercingImage} alt="Mid Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Mid Helix Piercing</h3>

          <p>
            Enhance your ear styling with our professional mid helix piercing services in the UAE, available at an affordable price of 150 AED. Mid helix piercing is a trendy cartilage piercing placed in the middle section of the outer ear, offering a perfectly balanced and chic look. It sits between the standard helix and upper ear, making it an ideal choice for those who want a stylish yet subtle addition to their ear design. Whether you prefer a minimal stud, a delicate hoop, or a combination of both, mid helix piercing allows you to create a refined and modern appearance that complements your personal style.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort to ensure a premium experience for every client. Our certified professionals use sterile, single-use, high-quality equipment to perform each mid helix piercing with precision and care. We strictly follow hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Our goal is to provide a quick, efficient, and pain-minimized experience, making mid helix piercing suitable for both first-time clients and those expanding their ear piercing collection.
          </p>

          <p>
            Mid helix piercing is perfect for individuals who want to achieve a balanced ear aesthetic. Its placement makes it highly versatile, allowing it to pair beautifully with other piercings such as lobe, tragus, conch, or upper helix. This creates a layered and curated ear look that is both fashionable and unique. Our expert specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear structure and style goals.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating for some, especially first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your mid helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your mid helix piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our mid helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted mid helix piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a balanced and chic look effortlessly. Book your mid helix piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Mid Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MidHelixPiercing;